// apiConfig.js
export const API_PREFIX = 'https://serviceapi.goodclub.hk/goodclub/api/';
//export const API_PREFIX = 'http://localhost:8085/api/';